module.exports = __webpack_public_path__ + "img/pc_logo_web.b52dc36c.png";